export const featurePermissionMapper: Record<string, string[]> = {
  COMPANIES: ['companies:read', 'companies:write'],
  ERGANI: ['ergani:access'],
  LEADS_MANAGEMENT: ['leads:read', 'leads:write'],
  STATISTICS: ['statistics:read'],
  INVOICING: ['invoicing:read', 'invoicing:write'],
};
